import {initSwagger} from './swagger';
import './style.css';

initSwagger();